import { SHTypography } from "@components/design-systems";
import { memo } from "react";
import { NumericFormat } from "react-number-format";

type Props = {
  value?: number | string | null;
  prefix?: string;
  suffix?: string;
  decimalScale?: number;
  forceDecimalScale?: boolean;
  renderValue?: (value: string) => JSX.Element;
};

export const DynamicNumberCell = memo(
  ({
    value,
    prefix,
    suffix,
    decimalScale = 2,
    forceDecimalScale = true,
    renderValue,
  }: Props) => {
    const renderedValueFunc = renderValue
      ? renderValue
      : (value: string) => (
          <SHTypography variant={"subtitle2"} lineHeight={"120%"} fontSize={13}>
            {value}
          </SHTypography>
        );

    const displayValue = Number(value);
    const shouldShowDecimalScale = Math.abs(displayValue) % 1 !== 0;

    return (
      <NumericFormat
        prefix={prefix}
        suffix={suffix}
        displayType="text"
        value={displayValue}
        thousandSeparator=","
        decimalScale={shouldShowDecimalScale ? decimalScale : 0}
        fixedDecimalScale={forceDecimalScale && shouldShowDecimalScale}
        renderText={renderedValueFunc}
      />
    );
  },
);
